export enum ProductPhotoPosition {
	Left = "Left",
	Right = "Right",
}
